// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION: { readonly version: string; [s: string]: any; } = {
    "dirty": false,
    "raw": "c4f21f4",
    "hash": "c4f21f4",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c4f21f4",
    "semverString": null,
    "version": "3.2.0-SNAPSHOT"
};
/* tslint:enable */
